import { useContext, useEffect, useState } from 'react'
import ConfirmationModal from 'src/consumer/components/helperComponents'
import {
  defaultConfirmationModalProps,
  genericHandleChange,
} from 'src/consumer/helpers/utilFunctions'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { SaveRestItem } from '../activity-utils'
import ActivityFeatureBase from './ActivityFeatureBase'
import { REST_FEATURE_OBJECT } from './restFeature/rest-class'
import RestCreationComponent from './restFeature/RestCreationComponent'

const FEATURE_TYPE_TO_COMPONENT_MAP = {
  rest: RestCreationComponent,
}

const FEATURE_TYPE_TO_OBJECT_MAP = {
  rest: REST_FEATURE_OBJECT,
}

export default function ActivityFeatureCreationComponentInjector({
  featureToCreate,
  setFeatureToCreate,
  featureType,
  onClose,
  changeActivityId,
}) {
  const [formData, setFormData] = useState()
  const [saving, setSaving] = useState(false)
  const [confirmationModalProps, setConfirmationModalProps] = useState(
    defaultConfirmationModalProps,
  )
  const ComponentToUse = FEATURE_TYPE_TO_COMPONENT_MAP[featureType]
  const { mentorProfileData } = useContext(MentorProfileContext)

  function handleChange(event) {
    genericHandleChange(event, setFormData)
  }

  async function handleSubmit() {
    setSaving(true)
    const baseObject = FEATURE_TYPE_TO_OBJECT_MAP?.[featureType]
    const dataToSubmit = { ...(baseObject || {}), ...formData }
    const resp = await SaveRestItem(dataToSubmit, mentorProfileData)
    console.log({ resp })
    if (resp.status === 200) {
      const responseRest = resp.data.data.rest
      changeActivityId({ ...responseRest, value: responseRest.id, label: responseRest.title })
      onClose()
    }
    setSaving(false)
  }

  async function showConfirmationModalBeforeSubmit() {
    setConfirmationModalProps({
      ...defaultConfirmationModalProps,
      action: 'save',
      body: 'Are you sure you want to save this feature?',
      onSubmitFunctions: [handleSubmit],
      visibility: true,
      visibilitySetter: setConfirmationModalProps,
    })
  }

  useEffect(() => {
    setFormData({ title: featureToCreate?.label })
  }, [featureToCreate])

  return (
    <>
      <ActivityFeatureBase
        formData={formData}
        setFormData={setFormData}
        handleChangeFeature={handleChange}
        handleSubmit={showConfirmationModalBeforeSubmit}
        saving={saving}
        onClose={onClose}
      >
        <ComponentToUse
          formData={formData}
          setFormData={setFormData}
          handleChangeFeature={handleChange}
        />
      </ActivityFeatureBase>
      <ConfirmationModal {...confirmationModalProps} newImplementation />
    </>
  )
}
